// extracted by mini-css-extract-plugin
export default {"cell":"NumericCell_cell__yLcrG"};